module.exports = __webpack_public_path__ + "img/arrow-media.b44b9bc3.svg";